import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CONTACT_EMAIL = "pong42@fun.com";
const DATA_REQUEST_URL =
  "https://app.termly.io/dsar/770c32cd-1581-4891-b8ec-514d92b3b38d";

function Privacy() {
  const { t } = useTranslation();
  const privacy = t("privacy", { returnObjects: true });
  const intro = Array.isArray(privacy.intro) ? privacy.intro : [];
  const summaryItems = Array.isArray(privacy.summaryItems)
    ? privacy.summaryItems
    : [];
  const sections = Array.isArray(privacy.sections) ? privacy.sections : [];

  return (
    <div className="mx-auto my-10 max-w-6xl px-4 text-white">
      <div className="rounded-3xl border border-white/10 bg-white/5 p-8 shadow-xl shadow-black/20 backdrop-blur md:p-10">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-violet-300/80">
          {privacy.kicker}
        </p>
        <h1 className="mt-3 text-4xl font-bold md:text-5xl">{privacy.title}</h1>
        <p className="mt-3 text-sm text-zinc-400">
          {privacy.updatedLabel}: {privacy.updatedDate}
        </p>

        <div className="mt-6 space-y-4 text-sm leading-7 text-zinc-200 md:text-base">
          {intro.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>

      <div className="mt-8 grid gap-8 lg:grid-cols-[minmax(0,1fr)_260px]">
        <div className="space-y-8">
          <section className="rounded-3xl border border-white/10 bg-zinc-950/40 p-6 shadow-lg shadow-black/10">
            <h2 className="text-2xl font-semibold">{privacy.summaryTitle}</h2>
            <p className="mt-3 text-sm leading-7 text-zinc-300 md:text-base">
              {privacy.summaryIntro}
            </p>
            <ul className="mt-5 space-y-3 text-sm leading-7 text-zinc-200 md:text-base">
              {summaryItems.map((item) => (
                <li key={item.anchor}>
                  <a
                    href={`#${item.anchor}`}
                    className="font-semibold text-violet-300 underline underline-offset-4"
                  >
                    {item.title}
                  </a>
                  {": "}
                  <span>{item.text}</span>
                </li>
              ))}
            </ul>
          </section>

          {sections.map((section) => (
            <section
              id={section.id}
              key={section.id}
              className="scroll-mt-24 rounded-3xl border border-white/10 bg-zinc-950/40 p-6 shadow-lg shadow-black/10"
            >
              <h2 className="text-2xl font-semibold">{section.title}</h2>

              {section.subtitle ? (
                <p className="mt-3 text-sm font-medium uppercase tracking-[0.18em] text-zinc-400">
                  {section.subtitle}
                </p>
              ) : null}

              {Array.isArray(section.paragraphs)
                ? section.paragraphs.map((paragraph, index) => (
                    <p
                      key={index}
                      className="mt-4 text-sm leading-7 text-zinc-200 md:text-base"
                    >
                      {paragraph}
                    </p>
                  ))
                : null}

              {Array.isArray(section.list) && section.list.length > 0 ? (
                <ul className="mt-4 list-disc space-y-2 pl-5 text-sm leading-7 text-zinc-200 md:text-base">
                  {section.list.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              ) : null}

              {section.emailLabel ? (
                <p className="mt-4 text-sm leading-7 text-zinc-200 md:text-base">
                  <span className="font-semibold text-white">{section.emailLabel}: </span>
                  <a
                    href={`mailto:${CONTACT_EMAIL}`}
                    className="text-violet-300 underline underline-offset-4"
                  >
                    {CONTACT_EMAIL}
                  </a>
                </p>
              ) : null}

              {Array.isArray(section.addressLines) && section.addressLines.length > 0 ? (
                <div className="mt-4 text-sm leading-7 text-zinc-200 md:text-base">
                  {section.addressLabel ? (
                    <p className="font-semibold text-white">{section.addressLabel}</p>
                  ) : null}
                  <p className="mt-1">
                    {section.addressLines.map((line, index) => (
                      <React.Fragment key={line}>
                        {line}
                        {index < section.addressLines.length - 1 ? <br /> : null}
                      </React.Fragment>
                    ))}
                  </p>
                </div>
              ) : null}

              {section.ctaLabel ? (
                <a
                  href={DATA_REQUEST_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-5 inline-flex rounded-full border border-violet-400/40 bg-violet-500/10 px-5 py-2 text-sm font-semibold text-violet-200 transition hover:border-violet-300 hover:bg-violet-500/20"
                >
                  {section.ctaLabel}
                </a>
              ) : null}
            </section>
          ))}

          <div className="pt-2">
            <Link
              to="/"
              className="inline-flex text-violet-300 underline underline-offset-4"
            >
              {privacy.backToHome}
            </Link>
          </div>
        </div>

        <aside className="h-fit rounded-3xl border border-white/10 bg-zinc-950/40 p-6 shadow-lg shadow-black/10 lg:sticky lg:top-24">
          <h2 className="text-lg font-semibold">{privacy.tocTitle}</h2>
          <nav className="mt-4 space-y-2 text-sm leading-6 text-zinc-300">
            {sections.map((section) => (
              <a
                key={section.id}
                href={`#${section.id}`}
                className="block transition hover:text-violet-300"
              >
                {section.title}
              </a>
            ))}
          </nav>
        </aside>
      </div>
    </div>
  );
}

export default Privacy;